import { analyticsApi } from '@bg-shared/business/Analytics';

class PLSMessagesTracker {
    private readonly TRACKED_PLS_EVENTS: Record<string, string> = {
        PLAYER_MUTED_GAME: 'PLAYER_MUTED_GAME',
        PLAYER_UNMUTED_GAME: 'PLAYER_UNMUTED_GAME',
        PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_ON: 'PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_ON',
        PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_OFF: 'PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_OFF',
        PLAYER_ADJUSTED_SETTING_GAME_SOUND: 'PLAYER_ADJUSTED_SETTING_GAME_SOUND',
        PLAYER_ADJUSTED_SETTING_DEALER_VOICE: 'PLAYER_ADJUSTED_SETTING_DEALER_VOICE',
        PLAYER_OPENED_GAME_SETTINGS: 'PLAYER_OPENED_GAME_SETTINGS',
        PLAYER_CLOSED_GAME_SETTINGS: 'PLAYER_CLOSED_GAME_SETTINGS',
        PLAYER_PRESSED_REPEAT: 'PLAYER_PRESSED_REPEAT',
        PLAYER_CHOSE_VIDEO_QUALITY_SETTINGS: 'PLAYER_CHOSE_VIDEO_QUALITY_SETTINGS',
        PLAYER_ENTERED_SCREENNAME: 'PLAYER_ENTERED_SCREENNAME',
        PLAYER_CHANGED_SCREENNAME: 'PLAYER_CHANGED_SCREENNAME',
        PLAYER_PRESSED_DEAL_NOW: 'PLAYER_PRESSED_DEAL_NOW',
        PLAYER_MADE_PREDECISION: 'PLAYER_MADE_PREDECISION',
    };

    public handleMessages(event: MessageEvent) {
        const { data } = event;

        if (data?.Name !== 'oac_player_input' || !_featuresConfig.trackPLSActions) {
            return;
        }

        switch (data.Body?.type) {
            case this.TRACKED_PLS_EVENTS.PLAYER_MUTED_GAME:
                analyticsApi.trackSoundSwitch(true);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_UNMUTED_GAME:
                analyticsApi.trackSoundSwitch(false);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_ON:
                analyticsApi.trackVideoQualityAutoAdjust(true);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_SET_VIDEO_QUALITY_AUTO_ADJUST_OFF:
                analyticsApi.trackVideoQualityAutoAdjust(false);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_ADJUSTED_SETTING_GAME_SOUND:
                analyticsApi.trackGameSoundSettingAdjust();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_ADJUSTED_SETTING_DEALER_VOICE:
                analyticsApi.trackGameSoundSettingAdjust();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_OPENED_GAME_SETTINGS:
                analyticsApi.trackGameSettingsOpened(true);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_CLOSED_GAME_SETTINGS:
                analyticsApi.trackGameSettingsOpened(false);
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_PRESSED_REPEAT:
                analyticsApi.trackPressedRepeat();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_CHOSE_VIDEO_QUALITY_SETTINGS:
                analyticsApi.trackVideoQualitySettingsChose();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_ENTERED_SCREENNAME:
                analyticsApi.trackScreenNameEnter();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_CHANGED_SCREENNAME:
                analyticsApi.trackScreenNameChange();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_PRESSED_DEAL_NOW:
                analyticsApi.trackPressedDealNow();
                break;
            case this.TRACKED_PLS_EVENTS.PLAYER_MADE_PREDECISION:
                analyticsApi.trackMadePredecision();
                break;
            default:
                break;
        }
    }
}

export const plsMessagesTracker = new PLSMessagesTracker();
